import {
  Paragraph,
  SectionType,
  TextRun,
  TabStopType,
  TabStopPosition,
  Tab,
  HeadingLevel,
  ExternalHyperlink,
  ISectionOptions,
} from 'docx'
import formatDate from '../common/date'
import { Resume } from '@/types/resume/v1'

const publications = ({ publications }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Publications',
        heading: HeadingLevel.HEADING_2,
      }),
      ...publications.reduce<Paragraph[]>((acc, pub) => {
        return [...acc, ...createPublicationItem(pub)]
      }, []),
    ],
  }
}

const createPublicationItem = (pub: Resume.Publication): Paragraph[] => {
  const item: Paragraph[] = []

  const publicationItemRun = pub.url
    ? new ExternalHyperlink({
      link: pub.url,
      children: [
        new TextRun({
          text: pub.name,
          bold: true,
        }),
      ],
    })
    : new TextRun({
      text: pub.name,
      bold: true,
    })

  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        publicationItemRun,
        new TextRun({
          children: [new Tab()],
        }),
        new TextRun({
          text: formatDate(pub.releaseDate),
        }),
      ],
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
    })
  )
  item.push(
    new Paragraph({
      text: pub.publisher,
    })
  )
  if (pub.summary) {
    item.push(
      new Paragraph({
        text: '\n',
      })
    )
    item.push(
      new Paragraph({
        text: pub.summary,
      })
    )
  }
  return item
}

export default publications
